import { RedirectConfig, RouteConfig, SubRouteConfig } from '@vfpf/vfpf-shared';

export type FormulierenRoutes = SubRouteConfig<
  RedirectConfig,
  {
    PreAdviesFormulier: RouteConfig;
    MijnFormulieren: RouteConfig;
  }
>;

export default (home: string): FormulierenRoutes => {
  const WrapperMain = home;
  const PreAdviesFormulier = '/het-formulier-pre-advies';
  const MijnFormulieren = '/mijn-formulieren';

  return {
    exact: true,
    path: WrapperMain,
    to: PreAdviesFormulier,
    menuTitle: "Het digitale formulier 'Resultaat pre-advies'",
    subRoutes: {
      PreAdviesFormulier: {
        exact: true,
        path: PreAdviesFormulier,
        menuTitle: 'Pre-advies formulier',
      },
      MijnFormulieren: {
        exact: true,
        path: MijnFormulieren,
        menuTitle: 'Mijn formulieren',
      },
    },
  };
};
